import React, { useEffect, useMemo, useState } from 'react'
import { checkGuess } from '../../utils/wordHelper'
import { FLIP_DELAY } from '../Wordle'
import GuessLetter from './GuessLetter'

type Props = {
  guess: string
  submitted: boolean
  word: string
}

const GuessWord = ({ guess, submitted, word }: Props) => {
  const [isFlipped, setIsFlipped] = useState(false)
  const [flippedLetters, setFlippedLetters] = useState<boolean[]>(
    new Array(word.length).fill(false)
  )

  const guessArray = Array.from(guess.padEnd(word.length))

  useEffect(() => {
    if (!submitted) return
    if (isFlipped) return

    setIsFlipped(true)

    flippedLetters.forEach((_, i) => {
      setTimeout(() => {
        setFlippedLetters(flippedLetters.map((_, j) => (i >= j ? true : false)))
      }, i * FLIP_DELAY)
    })
  }, [flippedLetters, isFlipped, submitted])

  const guessResults = useMemo(() => checkGuess(word, guess), [guess, word])

  return (
    <div className="flex flex-row justify-center mt-1">
      {guessResults.map((result, i) => {
        return (
          <GuessLetter
            key={i}
            letter={guessArray[i]}
            isActiveWord={!submitted && guess.length >= i + 1}
            isFlipped={flippedLetters[i]}
            isCorrect={result === '🟩'}
            isPresent={result === '🟨'}
            isSubmitted={submitted}
          />
        )
      })}
    </div>
  )
}

export default GuessWord
